module.exports = __webpack_public_path__ + "static/img/emt_example_payment2.14c22e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/emt_example_payment2.jpg
// module id = OUYr
// module chunks = 0